import React from "react";

const locations = [
  {
    number: "1",
    name: "Jezero Laguna",
    description: "Predivno jezero za opuštanje i uživanje u prirodi.",
    icons: ["fi-rs-water", "fi-rs-trees-alt"],
    time: "15min",
    distance: "2 km", // Dodavanje udaljenosti
  },
  {
    number: "2",
    name: "Vidikovac Vrh Vranac",
    description: "Spektakularni pogled na okolinu, savršeno za fotografije.",
    icons: ["fi-rs-direction-signal", "fi-rs-mountains", "fi fi-rs-binoculars"],
    time: "30min",
    distance: "4 km", // Dodavanje udaljenosti
  },
  {
    number: "3",
    name: "Staza Kotara",
    description: "Lagano planinarenje kroz šumu za sve uzraste.",
    icons: ["fi-rs-trees-alt", "fi-rs-road", "fi fi-rs-rabbit"],
    time: "45min",
    distance: "6 km", // Dodavanje udaljenosti
  },
  {
    number: "4",
    name: "Lička livada",
    description: "Idilično mjesto za piknik i promatranje zalaska sunca.",
    icons: ["fi-rs-sun", "fi-rs-grass", "fi fi-rs-salad"],
    time: "60min",
    distance: "3 km", // Dodavanje udaljenosti
  },
];

const HomeExplore = () => {
  return (
    <div id="istrazi" className="explore">
      <h2>Istraži okolinu</h2>
      <div className="explore-grid">
        {locations.map((location, index) => (
          <div key={index} className="explore-box">
            <div className="explore-title">
              <h3>{location.number}</h3>
              <div className="title">
                <h5>
                  {location.name}
                  <div>
                    {/* Prikazivanje ikona specifičnih za ovu lokaciju */}
                    {location.icons.map((icon, i) => (
                      <i key={i} className={`fi ${icon}`}></i>
                    ))}
                  </div>
                </h5>
              </div>
            </div>
            {/* Prikazivanje vremena specifičnog za ovu lokaciju */}
            <h6>
              <i className="fi fi-rs-clock-three"></i> {location.time} /
              <i className="fi fi-rs-user-roadmap"></i> {location.distance}
            </h6>
            <p className="explore-description">{location.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomeExplore;
